module.exports = __webpack_public_path__ + "received-benefit-white.svg?c4ddbc34428624800df54017e7523432";